export const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};

export const translations = {
  newRequest: 'О новых заявках',
  newComment: 'О новых комментариях',
};
